import React from 'react';
import './PhaseNavigation.css';
import { PHASES } from '../../constants';

const PhaseNavigation = ({ currentPhase, onPhaseChange, availablePhases = [], phaseLocks = {} }) => {
  return (
    <div className="phase-navigation">
      {PHASES.map((phase) => {
        const isAvailable = availablePhases.includes(phase.id);
        const isLocked = phaseLocks[`phase${phase.id}`] || false;
        const isActive = currentPhase === phase.id;
        const canAccess = isAvailable && !isLocked;
        
        return (
          <button
            key={phase.id}
            className={`phase-tab ${isActive ? 'active' : ''} ${!canAccess ? 'disabled' : ''} ${isLocked ? 'locked' : ''}`}
            onClick={() => canAccess && onPhaseChange(phase.id)}
            disabled={!canAccess}
            title={isLocked ? 'Denne fase er låst af admin' : !isAvailable ? 'Fase ikke tilgængelig endnu' : ''}
          >
            {phase.name}
            {isLocked && <span className="lock-icon">🔒</span>}
            {!isAvailable && !isLocked && <span className="unavailable-icon">⏳</span>}
          </button>
        );
      })}
    </div>
  );
};

export default PhaseNavigation;
